module.exports = __webpack_public_path__ + "img/icon3.ca536bdd.png";